import { render, staticRenderFns } from "./FttbRegrades.vue?vue&type=template&id=8ebdd210&scoped=true&"
import script from "./FttbRegrades.vue?vue&type=script&lang=js&"
export * from "./FttbRegrades.vue?vue&type=script&lang=js&"
import style0 from "./FttbRegrades.vue?vue&type=style&index=0&id=8ebdd210&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebdd210",
  null
  
)

export default component.exports